
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const AnnouncementPlacement = {
  teacher_my_schedule: 'teacher_my_schedule'
} as const

export type AnnouncementPlacement = (typeof AnnouncementPlacement)[keyof typeof AnnouncementPlacement]


export const AnnouncementType = {
  general: 'general',
  informative: 'informative',
  success: 'success',
  caution: 'caution',
  urgent: 'urgent'
} as const

export type AnnouncementType = (typeof AnnouncementType)[keyof typeof AnnouncementType]


export const AnnouncementStatus = {
  active: 'active',
  inactive: 'inactive'
} as const

export type AnnouncementStatus = (typeof AnnouncementStatus)[keyof typeof AnnouncementStatus]


export const AssessmentFormat = {
  diagnostic_word_list: 'diagnostic_word_list',
  mastery_check_reading_fluency_passage: 'mastery_check_reading_fluency_passage',
  mastery_check_reading_fluency_passage_v2: 'mastery_check_reading_fluency_passage_v2',
  mastery_check_phonemic_reading: 'mastery_check_phonemic_reading',
  mastery_check_reading: 'mastery_check_reading',
  mastery_check_skill_preview: 'mastery_check_skill_preview',
  mastery_check_comprehesion_skill: 'mastery_check_comprehesion_skill',
  mastery_check_comprehesion_passage: 'mastery_check_comprehesion_passage',
  progress_monitor_words: 'progress_monitor_words',
  progress_monitor_words_v2: 'progress_monitor_words_v2',
  progress_monitor_sounds: 'progress_monitor_sounds',
  progress_monitor_sounds_v2: 'progress_monitor_sounds_v2',
  progress_monitor_letter_names: 'progress_monitor_letter_names',
  progress_monitor_letter_names_v2: 'progress_monitor_letter_names_v2',
  progress_monitor_text: 'progress_monitor_text',
  fluency_check: 'fluency_check',
  grade_level_fluency: 'grade_level_fluency',
  grade_level_fluency_v2: 'grade_level_fluency_v2'
} as const

export type AssessmentFormat = (typeof AssessmentFormat)[keyof typeof AssessmentFormat]


export const AssessmentContentStatus = {
  active: 'active',
  inactive: 'inactive'
} as const

export type AssessmentContentStatus = (typeof AssessmentContentStatus)[keyof typeof AssessmentContentStatus]


export const OrgType = {
  district: 'district',
  individual: 'individual',
  foundation: 'foundation'
} as const

export type OrgType = (typeof OrgType)[keyof typeof OrgType]


export const OrgStatus = {
  active: 'active',
  inactive: 'inactive'
} as const

export type OrgStatus = (typeof OrgStatus)[keyof typeof OrgStatus]


export const SchoolStatus = {
  active: 'active',
  inactive: 'inactive'
} as const

export type SchoolStatus = (typeof SchoolStatus)[keyof typeof SchoolStatus]


export const VideoConferenceType = {
  zoom: 'zoom',
  googleMeet: 'googleMeet'
} as const

export type VideoConferenceType = (typeof VideoConferenceType)[keyof typeof VideoConferenceType]


export const OrgFeedbackType = {
  airFeedback: 'airFeedback',
  parentFeedback: 'parentFeedback'
} as const

export type OrgFeedbackType = (typeof OrgFeedbackType)[keyof typeof OrgFeedbackType]


export const TechCheckType = {
  zoomTechCheck: 'zoomTechCheck',
  googleMeetTechCheck: 'googleMeetTechCheck'
} as const

export type TechCheckType = (typeof TechCheckType)[keyof typeof TechCheckType]


export const CoachAvailabilityType = {
  regular: 'regular',
  substitute: 'substitute'
} as const

export type CoachAvailabilityType = (typeof CoachAvailabilityType)[keyof typeof CoachAvailabilityType]


export const CoachSessionIncentiveType = {
  lateSubstitution: 'lateSubstitution',
  completion: 'completion'
} as const

export type CoachSessionIncentiveType = (typeof CoachSessionIncentiveType)[keyof typeof CoachSessionIncentiveType]


export const NonSessionPaymentType = {
  incentive: 'incentive',
  adjustment: 'adjustment',
  referral: 'referral',
  mentoring: 'mentoring',
  workshop: 'workshop',
  reimbursement: 'reimbursement',
  teacher_support: 'teacher_support',
  curriculum_support: 'curriculum_support',
  school_support: 'school_support',
  class_adjustment: 'class_adjustment',
  new_teacher_onboarding: 'new_teacher_onboarding',
  pay_in_lieu_of_notice: 'pay_in_lieu_of_notice',
  extended_teaching: 'extended_teaching',
  admin_cancellations: 'admin_cancellations',
  outreach_and_community: 'outreach_and_community',
  family_teaching: 'family_teaching'
} as const

export type NonSessionPaymentType = (typeof NonSessionPaymentType)[keyof typeof NonSessionPaymentType]


export const CoachPaymentStatus = {
  not_started: 'not_started',
  processing: 'processing',
  scheduled: 'scheduled',
  pending_approval: 'pending_approval',
  processed: 'processed',
  failed: 'failed'
} as const

export type CoachPaymentStatus = (typeof CoachPaymentStatus)[keyof typeof CoachPaymentStatus]


export const CoachPaymentType = {
  teaching: 'teaching',
  non_session: 'non_session'
} as const

export type CoachPaymentType = (typeof CoachPaymentType)[keyof typeof CoachPaymentType]


export const CoachPaymentNote = {
  send_manually: 'send_manually',
  account_issue: 'account_issue',
  name_issue: 'name_issue',
  no_bank_info: 'no_bank_info',
  overpaid: 'overpaid',
  overpayment_adjusted: 'overpayment_adjusted'
} as const

export type CoachPaymentNote = (typeof CoachPaymentNote)[keyof typeof CoachPaymentNote]


export const PurgeRequestPurgeType = {
  school: 'school',
  org: 'org'
} as const

export type PurgeRequestPurgeType = (typeof PurgeRequestPurgeType)[keyof typeof PurgeRequestPurgeType]


export const PurgeActionStatus = {
  requested: 'requested',
  inProgress: 'inProgress',
  complete: 'complete',
  error: 'error'
} as const

export type PurgeActionStatus = (typeof PurgeActionStatus)[keyof typeof PurgeActionStatus]


export const PurgeRequestTableName = {
  schoolReportSessions: 'schoolReportSessions',
  schoolReports: 'schoolReports',
  assessmentResults: 'assessmentResults',
  sessionFeedbacks: 'sessionFeedbacks',
  sessionFeedbackTimeTrackings: 'sessionFeedbackTimeTrackings',
  studentFeedbacks: 'studentFeedbacks',
  onDemandGLAs: 'onDemandGLAs',
  studentSessions: 'studentSessions',
  studentContacts: 'studentContacts',
  studentShortLinks: 'studentShortLinks',
  studentStatusAudits: 'studentStatusAudits',
  edlinkUserAssociations: 'edlinkUserAssociations',
  v1UserAssociations: 'v1UserAssociations',
  userIdentities: 'userIdentities',
  userRoles: 'userRoles',
  students: 'students',
  users: 'users'
} as const

export type PurgeRequestTableName = (typeof PurgeRequestTableName)[keyof typeof PurgeRequestTableName]


export const SessionFeedbackIssue = {
  Extremely_noisy: 'Extremely_noisy',
  Constantly_late: 'Constantly_late',
  Strong_behavior_issues: 'Strong_behavior_issues',
  late: 'late',
  left_early: 'left_early',
  tech_issue: 'tech_issue',
  disruptive_or_disrespectful: 'disruptive_or_disrespectful',
  extreme_concerns: 'extreme_concerns',
  other: 'other',
  Audio_issues: 'Audio_issues',
  Video_issues: 'Video_issues',
  Connection_issues: 'Connection_issues',
  Other_tech_issues: 'Other_tech_issues',
  Too_easy: 'Too_easy',
  Too_hard: 'Too_hard'
} as const

export type SessionFeedbackIssue = (typeof SessionFeedbackIssue)[keyof typeof SessionFeedbackIssue]


export const StudentFeedbackIssue = {
  attendance_issue: 'attendance_issue',
  behavior_issue: 'behavior_issue',
  learning_issue: 'learning_issue',
  tech_issue: 'tech_issue'
} as const

export type StudentFeedbackIssue = (typeof StudentFeedbackIssue)[keyof typeof StudentFeedbackIssue]


export const StudentFeedbackStatus = {
  need_review: 'need_review',
  check_again: 'check_again',
  level_change_needed: 'level_change_needed',
  resolved: 'resolved'
} as const

export type StudentFeedbackStatus = (typeof StudentFeedbackStatus)[keyof typeof StudentFeedbackStatus]


export const SessionFeedbackLevel = {
  Too_easy: 'Too_easy',
  Too_hard: 'Too_hard'
} as const

export type SessionFeedbackLevel = (typeof SessionFeedbackLevel)[keyof typeof SessionFeedbackLevel]


export const OnDemandGLARecordedStatus = {
  recorded: 'recorded',
  under_review: 'under_review',
  not_recorded: 'not_recorded'
} as const

export type OnDemandGLARecordedStatus = (typeof OnDemandGLARecordedStatus)[keyof typeof OnDemandGLARecordedStatus]


export const JobStatus = {
  idle: 'idle',
  running: 'running'
} as const

export type JobStatus = (typeof JobStatus)[keyof typeof JobStatus]


export const ScheduleStatus = {
  draft: 'draft',
  open: 'open',
  closed: 'closed',
  archived: 'archived',
  deleted: 'deleted'
} as const

export type ScheduleStatus = (typeof ScheduleStatus)[keyof typeof ScheduleStatus]


export const ClassTimeType = {
  recurring: 'recurring',
  one_time: 'one_time'
} as const

export type ClassTimeType = (typeof ClassTimeType)[keyof typeof ClassTimeType]


export const ClassTimeStatus = {
  active: 'active',
  archived: 'archived',
  deleted: 'deleted'
} as const

export type ClassTimeStatus = (typeof ClassTimeStatus)[keyof typeof ClassTimeStatus]


export const SessionStatus = {
  scheduled: 'scheduled',
  in_progress: 'in_progress',
  completed: 'completed',
  cancelled: 'cancelled',
  archived: 'archived'
} as const

export type SessionStatus = (typeof SessionStatus)[keyof typeof SessionStatus]


export const SessionAlert = {
  coach_conflict: 'coach_conflict',
  coach_missing: 'coach_missing'
} as const

export type SessionAlert = (typeof SessionAlert)[keyof typeof SessionAlert]


export const SubstitutionRequestStatus = {
  pending: 'pending',
  fulfilled: 'fulfilled',
  cancelled: 'cancelled'
} as const

export type SubstitutionRequestStatus = (typeof SubstitutionRequestStatus)[keyof typeof SubstitutionRequestStatus]


export const SubstitutionRequestType = {
  requested_sub_by_coach: 'requested_sub_by_coach',
  coach_no_show: 'coach_no_show',
  assigned_by_admin: 'assigned_by_admin'
} as const

export type SubstitutionRequestType = (typeof SubstitutionRequestType)[keyof typeof SubstitutionRequestType]


export const CoachSessionRemarkV2 = {
  canceled: 'canceled',
  canceledWithin12Hours: 'canceledWithin12Hours',
  subClass: 'subClass',
  subClassWithin12Hours: 'subClassWithin12Hours',
  lateStart: 'lateStart',
  endEarly: 'endEarly',
  tns: 'tns'
} as const

export type CoachSessionRemarkV2 = (typeof CoachSessionRemarkV2)[keyof typeof CoachSessionRemarkV2]


export const OriginalTeacherIssue = {
  tns_general_no_show: 'tns_general_no_show',
  regular_sub_request: 'regular_sub_request',
  short_notice_sub_request: 'short_notice_sub_request',
  regular_sub_request_excused: 'regular_sub_request_excused',
  short_notice_sub_request_excused: 'short_notice_sub_request_excused',
  tns_sub_requested: 'tns_sub_requested',
  tns_double_booking: 'tns_double_booking',
  tns_teacher_emergency: 'tns_teacher_emergency',
  tns_left_early: 'tns_left_early',
  tns_scheduling_error: 'tns_scheduling_error',
  tns_late_to_class: 'tns_late_to_class',
  tns_sub_no_show: 'tns_sub_no_show',
  tns_wrong_link: 'tns_wrong_link',
  tit_general_end_early: 'tit_general_end_early',
  tit_internet_power_outage: 'tit_internet_power_outage',
  tit_zoom_meet_issue: 'tit_zoom_meet_issue',
  tit_sound_video: 'tit_sound_video',
  tit_internet_connection_issue: 'tit_internet_connection_issue'
} as const

export type OriginalTeacherIssue = (typeof OriginalTeacherIssue)[keyof typeof OriginalTeacherIssue]


export const LearningLoss = {
  five_mins: 'five_mins',
  five_to_ten_mins: 'five_to_ten_mins',
  ten_mins: 'ten_mins',
  never_started: 'never_started'
} as const

export type LearningLoss = (typeof LearningLoss)[keyof typeof LearningLoss]


export const SubstitutionRequestOrigin = {
  manual: 'manual',
  automatic_conflict: 'automatic_conflict'
} as const

export type SubstitutionRequestOrigin = (typeof SubstitutionRequestOrigin)[keyof typeof SubstitutionRequestOrigin]


export const StudentContactType = {
  school_parent: 'school_parent',
  family_parent: 'family_parent'
} as const

export type StudentContactType = (typeof StudentContactType)[keyof typeof StudentContactType]


export const TeacherAttendancePolicyVersion = {
  V2_2026_27: 'V2_2026_27'
} as const

export type TeacherAttendancePolicyVersion = (typeof TeacherAttendancePolicyVersion)[keyof typeof TeacherAttendancePolicyVersion]


export const TeacherAttendancePolicyUsageKind = {
  regular_sub_request: 'regular_sub_request',
  short_notice_sub_request: 'short_notice_sub_request',
  no_show: 'no_show'
} as const

export type TeacherAttendancePolicyUsageKind = (typeof TeacherAttendancePolicyUsageKind)[keyof typeof TeacherAttendancePolicyUsageKind]


export const TeacherAttendancePolicyTriggerDimension = {
  total_sub_requests: 'total_sub_requests',
  short_notice_sub_requests: 'short_notice_sub_requests'
} as const

export type TeacherAttendancePolicyTriggerDimension = (typeof TeacherAttendancePolicyTriggerDimension)[keyof typeof TeacherAttendancePolicyTriggerDimension]


export const TeacherAttendancePolicyActionLevel = {
  within_allowance: 'within_allowance',
  final_warning: 'final_warning',
  reassignment_eligible: 'reassignment_eligible',
  third_no_show: 'third_no_show',
  third_late_entry: 'third_late_entry',
  third_early_exit: 'third_early_exit',
  final_14_day_protected: 'final_14_day_protected'
} as const

export type TeacherAttendancePolicyActionLevel = (typeof TeacherAttendancePolicyActionLevel)[keyof typeof TeacherAttendancePolicyActionLevel]


export const StudentGroupStatus = {
  active: 'active',
  archived: 'archived'
} as const

export type StudentGroupStatus = (typeof StudentGroupStatus)[keyof typeof StudentGroupStatus]


export const AttendanceStatus = {
  at_risk: 'at_risk',
  triggered: 'triggered',
  reassigned: 'reassigned'
} as const

export type AttendanceStatus = (typeof AttendanceStatus)[keyof typeof AttendanceStatus]


export const EmailsSent = {
  first_warning: 'first_warning',
  maximum_limit: 'maximum_limit',
  reassignment: 'reassignment'
} as const

export type EmailsSent = (typeof EmailsSent)[keyof typeof EmailsSent]


export const StudentGroupReassignmentReason = {
  tns_spp: 'tns_spp',
  exceeded_planned_absences_spp: 'exceeded_planned_absences_spp',
  exceeded_short_notice_absences_spp: 'exceeded_short_notice_absences_spp',
  prohibit_act_policy_violation: 'prohibit_act_policy_violation',
  tq_issue: 'tq_issue',
  student_leveling_issue: 'student_leveling_issue',
  contract_termination_or_non_renewal: 'contract_termination_or_non_renewal',
  unresponsive_to_zoom_link: 'unresponsive_to_zoom_link',
  school_complaint: 'school_complaint',
  teacher_request: 'teacher_request'
} as const

export type StudentGroupReassignmentReason = (typeof StudentGroupReassignmentReason)[keyof typeof StudentGroupReassignmentReason]


export const StudentGroupReassignmentRequestStatus = {
  requested: 'requested',
  processing: 'processing',
  resolved: 'resolved'
} as const

export type StudentGroupReassignmentRequestStatus = (typeof StudentGroupReassignmentRequestStatus)[keyof typeof StudentGroupReassignmentRequestStatus]


export const AssessmentReviewRequestStatus = {
  requested: 'requested',
  fulfilled: 'fulfilled',
  cancelled: 'cancelled'
} as const

export type AssessmentReviewRequestStatus = (typeof AssessmentReviewRequestStatus)[keyof typeof AssessmentReviewRequestStatus]


export const UserRoleStatus = {
  active: 'active',
  inactive: 'inactive'
} as const

export type UserRoleStatus = (typeof UserRoleStatus)[keyof typeof UserRoleStatus]


export const Role = {
  parent: 'parent',
  coach: 'coach',
  student: 'student',
  org_admin: 'org_admin',
  school_admin: 'school_admin',
  school_contact: 'school_contact',
  air_admin: 'air_admin',
  air_limited_admin: 'air_limited_admin',
  edge_coach: 'edge_coach'
} as const

export type Role = (typeof Role)[keyof typeof Role]


export const StudentStatus = {
  enrolled: 'enrolled',
  dropped: 'dropped',
  program_concluded: 'program_concluded'
} as const

export type StudentStatus = (typeof StudentStatus)[keyof typeof StudentStatus]


export const StudentYear = {
  Pre_K: 'Pre_K',
  K: 'K',
  first: 'first',
  second: 'second',
  third: 'third',
  fourth: 'fourth',
  fifth: 'fifth',
  sixth: 'sixth',
  seventh: 'seventh',
  eighth: 'eighth',
  ninth: 'ninth',
  tenth: 'tenth',
  eleventh: 'eleventh',
  twelfth: 'twelfth',
  thirteenth: 'thirteenth'
} as const

export type StudentYear = (typeof StudentYear)[keyof typeof StudentYear]


export const CoachStatus = {
  onboarding: 'onboarding',
  ready_to_teach: 'ready_to_teach',
  offboarded: 'offboarded',
  pause: 'pause'
} as const

export type CoachStatus = (typeof CoachStatus)[keyof typeof CoachStatus]


export const CoachSubStatus = {
  offboard_requested: 'offboard_requested',
  teacher_requested: 'teacher_requested',
  teaching_quality_issues: 'teaching_quality_issues',
  tech_issues: 'tech_issues',
  absenteeism: 'absenteeism',
  non_renewal_of_contract: 'non_renewal_of_contract',
  c_background: 'c_background',
  n_background: 'n_background',
  checkr_issue: 'checkr_issue',
  zoom_unresponsive: 'zoom_unresponsive'
} as const

export type CoachSubStatus = (typeof CoachSubStatus)[keyof typeof CoachSubStatus]


export const CoachGrade = {
  S: 'S',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  New: 'New'
} as const

export type CoachGrade = (typeof CoachGrade)[keyof typeof CoachGrade]


export const CoachAttendanceGrade = {
  S: 'S',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  Never_Taught: 'Never_Taught'
} as const

export type CoachAttendanceGrade = (typeof CoachAttendanceGrade)[keyof typeof CoachAttendanceGrade]


export const CoachOverallGrade = {
  S: 'S',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  Never_Taught: 'Never_Taught',
  Not_reviewed: 'Not_reviewed'
} as const

export type CoachOverallGrade = (typeof CoachOverallGrade)[keyof typeof CoachOverallGrade]


export const CoachTqReviewType = {
  QR_New_First: 'QR_New_First',
  FR_New_Second: 'FR_New_Second',
  FR_Current: 'FR_Current',
  QR_Return: 'QR_Return',
  Assessment: 'Assessment'
} as const

export type CoachTqReviewType = (typeof CoachTqReviewType)[keyof typeof CoachTqReviewType]


export const CoachTqReviewStatus = {
  blank: 'blank',
  in_progress: 'in_progress',
  done: 'done'
} as const

export type CoachTqReviewStatus = (typeof CoachTqReviewStatus)[keyof typeof CoachTqReviewStatus]


export const ClassEligibility = {
  can_teach_intervention: 'can_teach_intervention',
  can_teach_practice: 'can_teach_practice',
  can_teach_diagnostic: 'can_teach_diagnostic',
  air_crew: 'air_crew',
  imported_from_v1: 'imported_from_v1'
} as const

export type ClassEligibility = (typeof ClassEligibility)[keyof typeof ClassEligibility]


export const BackgroundCheckStatus = {
  checkr_passed: 'checkr_passed',
  ebr_fingerprint_passed: 'ebr_fingerprint_passed',
  ebr_fingerprint_quality_reject: 'ebr_fingerprint_quality_reject',
  california_fingerprint_passed: 'california_fingerprint_passed',
  florida_fingerprint_passed: 'florida_fingerprint_passed',
  florida_foundations_course_completed: 'florida_foundations_course_completed',
  uva_cleared: 'uva_cleared',
  louisiana_can: 'louisiana_can'
} as const

export type BackgroundCheckStatus = (typeof BackgroundCheckStatus)[keyof typeof BackgroundCheckStatus]


export const ZoomType = {
  basic: 'basic',
  license: 'license',
  permanent_license: 'permanent_license'
} as const

export type ZoomType = (typeof ZoomType)[keyof typeof ZoomType]


export const ZoomInviteStatus = {
  not_sent: 'not_sent',
  invited: 'invited',
  accepted: 'accepted'
} as const

export type ZoomInviteStatus = (typeof ZoomInviteStatus)[keyof typeof ZoomInviteStatus]


export const PaymentAccountType = {
  ach: 'ach',
  domestic_wire: 'domestic_wire',
  cheque: 'cheque',
  international_wire: 'international_wire'
} as const

export type PaymentAccountType = (typeof PaymentAccountType)[keyof typeof PaymentAccountType]


export const TeachingPreference = {
  regular_schedule: 'regular_schedule',
  substitute_teaching: 'substitute_teaching'
} as const

export type TeachingPreference = (typeof TeachingPreference)[keyof typeof TeachingPreference]


export const StudentTag = {
  obc: 'obc',
  eir: 'eir'
} as const

export type StudentTag = (typeof StudentTag)[keyof typeof StudentTag]


export const GlaFollowUpStatus = {
  need_follow_up: 'need_follow_up',
  check_again: 'check_again',
  resolved: 'resolved'
} as const

export type GlaFollowUpStatus = (typeof GlaFollowUpStatus)[keyof typeof GlaFollowUpStatus]


export const GoogleMeetEvaluationStatus = {
  send_message: 'send_message',
  no_action_needed: 'no_action_needed'
} as const

export type GoogleMeetEvaluationStatus = (typeof GoogleMeetEvaluationStatus)[keyof typeof GoogleMeetEvaluationStatus]


export const UserIdentityStatus = {
  active: 'active',
  inactive: 'inactive',
  registrable: 'registrable'
} as const

export type UserIdentityStatus = (typeof UserIdentityStatus)[keyof typeof UserIdentityStatus]


export const Season = {
  spring: 'spring',
  summer: 'summer',
  fall: 'fall'
} as const

export type Season = (typeof Season)[keyof typeof Season]


export const CoachOnboardingStatus = {
  Demo_Invited: 'Demo_Invited',
  Review_Demo: 'Review_Demo',
  Demo_Pass: 'Demo_Pass',
  Not_a_Fit: 'Not_a_Fit',
  Not_Now__Pending_: 'Not_Now__Pending_',
  Contract_Sent: 'Contract_Sent',
  Slack_Invited: 'Slack_Invited',
  Create_Accounts: 'Create_Accounts',
  App_Invited: 'App_Invited',
  Review_Checklist: 'Review_Checklist',
  In_Slack_and_Zoom_Ready: 'In_Slack_and_Zoom_Ready',
  Old_Demo: 'Old_Demo',
  New: 'New'
} as const

export type CoachOnboardingStatus = (typeof CoachOnboardingStatus)[keyof typeof CoachOnboardingStatus]


export const DayOfWeek = {
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
  sunday: 'sunday'
} as const

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek]
